import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getCurrentTime16j9973nx5x63 as getCurrentTime } from './internal/KLoggingClock.mjs';
import {
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var KLoggingEventClass;
function KLoggingEvent() {
  if (KLoggingEventClass === VOID) {
    class $ {
      constructor(level, marker, loggerName, message, cause, payload, timestamp) {
        return new.target.new_io_github_oshai_kotlinlogging_KLoggingEvent_953r86_k$(level, marker, loggerName, message, cause, payload, timestamp);
      }
      static new_io_github_oshai_kotlinlogging_KLoggingEvent_953r86_k$(level, marker, loggerName, message, cause, payload, timestamp) {
        message = message === VOID ? null : message;
        cause = cause === VOID ? null : cause;
        payload = payload === VOID ? null : payload;
        timestamp = timestamp === VOID ? getCurrentTime() : timestamp;
        var $this = createThis(this);
        $this.level_1 = level;
        $this.marker_1 = marker;
        $this.loggerName_1 = loggerName;
        $this.message_1 = message;
        $this.cause_1 = cause;
        $this.payload_1 = payload;
        $this.timestamp_1 = timestamp;
        return $this;
      }
      static new_io_github_oshai_kotlinlogging_KLoggingEvent_tww1re_k$(level, marker, loggerName, eventBuilder) {
        return this.new_io_github_oshai_kotlinlogging_KLoggingEvent_953r86_k$(level, marker, loggerName, eventBuilder.message_1, eventBuilder.cause_1, eventBuilder.payload_1);
      }
      toString() {
        return 'KLoggingEvent(level=' + this.level_1.toString() + ', marker=' + toString(this.marker_1) + ', loggerName=' + this.loggerName_1 + ', message=' + this.message_1 + ', cause=' + toString(this.cause_1) + ', payload=' + toString(this.payload_1) + ', timestamp=' + this.timestamp_1.toString() + ')';
      }
      hashCode() {
        var result = this.level_1.hashCode();
        result = imul(result, 31) + (this.marker_1 == null ? 0 : hashCode(this.marker_1)) | 0;
        result = imul(result, 31) + getStringHashCode(this.loggerName_1) | 0;
        result = imul(result, 31) + (this.message_1 == null ? 0 : getStringHashCode(this.message_1)) | 0;
        result = imul(result, 31) + (this.cause_1 == null ? 0 : hashCode(this.cause_1)) | 0;
        result = imul(result, 31) + (this.payload_1 == null ? 0 : hashCode(this.payload_1)) | 0;
        result = imul(result, 31) + getBigIntHashCode(this.timestamp_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof KLoggingEvent()))
          return false;
        var tmp0_other_with_cast = other instanceof KLoggingEvent() ? other : THROW_CCE();
        if (!this.level_1.equals(tmp0_other_with_cast.level_1))
          return false;
        if (!equals(this.marker_1, tmp0_other_with_cast.marker_1))
          return false;
        if (!(this.loggerName_1 === tmp0_other_with_cast.loggerName_1))
          return false;
        if (!(this.message_1 == tmp0_other_with_cast.message_1))
          return false;
        if (!equals(this.cause_1, tmp0_other_with_cast.cause_1))
          return false;
        if (!equals(this.payload_1, tmp0_other_with_cast.payload_1))
          return false;
        if (!(this.timestamp_1 === tmp0_other_with_cast.timestamp_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'KLoggingEvent');
    KLoggingEventClass = $;
  }
  return KLoggingEventClass;
}
//region block: exports
export {
  KLoggingEvent as KLoggingEvent3el01063mcenm,
};
//endregion

//# sourceMappingURL=KLoggingEvent.mjs.map
